/* Scheduled display only. Does not change prices, carts, payment methods or discounts. */
(() => {
  const saleEnd = Date.parse('2026-10-21T00:00:00+05:30');
  function restoreRegularPrices() {
    if (Date.now() < saleEnd) return;
    for (const option of document.querySelectorAll('option[data-festival-regular]')) {
      option.dataset.price = option.dataset.festivalRegular;
      option.dataset.priceAmount = option.dataset.festivalRegularAmount;
      option.dataset.compare = option.dataset.festivalCompare || '';
      option.dataset.compareAmount = option.dataset.festivalCompareAmount || '';
      option.dataset.save = option.dataset.festivalSave || '';
      option.removeAttribute('data-festival-regular');
    }
    for (const surface of document.querySelectorAll('[data-festival-price]')) {
      const price = surface.querySelector('.card__price span, .now');
      if (price) price.textContent = surface.dataset.festivalRegular;
      for (const badge of surface.querySelectorAll('.card__badge, .pdp__off, .price-save, s')) badge.remove();
      const compare = surface.dataset.festivalCompare;
      if (compare) {
        const was = document.createElement('s'); was.textContent = compare;
        if (surface.id === 'pdp-price') was.id = 'pdp-price-was';   // the variant script reuses it instead of adding a second
        (surface.querySelector('.card__price') || surface).append(was);
      }
      if (surface.id === 'pdp-price') {
        const sticky = document.getElementById('pdp-sticky-price');
        if (sticky) sticky.textContent = surface.dataset.festivalRegular;
      }
      surface.removeAttribute('data-festival-price');
    }
    for (const script of document.querySelectorAll('script[data-festival-offer-price]')) {
      try {
        const data = JSON.parse(script.textContent);
        data.offers.price = String(Number(script.dataset.festivalOfferPrice) / 100);
        delete data.offers.priceValidUntil;
        script.textContent = JSON.stringify(data).replaceAll('<', '\\u003c');
        script.removeAttribute('data-festival-offer-price');
      } catch {}
    }
    document.getElementById('pdp-variant-select')?.dispatchEvent(new Event('change'));
  }
  restoreRegularPrices();
  document.addEventListener('visibilitychange', restoreRegularPrices);
  window.addEventListener('pageshow', restoreRegularPrices);
  if (Date.now() < saleEnd) setTimeout(restoreRegularPrices, Math.min(saleEnd - Date.now(), 2147483647));
  class LuveeFestival extends HTMLElement {
    #timer;

    connectedCallback() {
      this.update();
      if (this.querySelector('[data-festival-label], [data-festival-promo], [data-festival-evergreen][hidden]')) {
        this.#timer = setInterval(() => this.update(), 1000);
      }
    }

    disconnectedCallback() {
      clearInterval(this.#timer);
    }

    update() {
      const start = Date.parse(this.dataset.start);
      const end = Date.parse(this.dataset.end);
      const now = Date.now();
      if (!Number.isFinite(start) || !Number.isFinite(end) || start >= end || now >= end) {
        const fallback = this.querySelector('[data-festival-evergreen-template]');
        const promo = this.querySelector('[data-festival-promo]');
        if (fallback && promo) promo.replaceWith(fallback.content.cloneNode(true));
        else promo?.remove();
        fallback?.remove();
        for (const evergreen of this.querySelectorAll('[data-festival-evergreen]')) evergreen.hidden = false;
        this.querySelector('.festival-status')?.remove();
        document.body.classList.remove('festival-theme');
        clearInterval(this.#timer);
        return;
      }
      const upcoming = now < start;
      if (!upcoming) {
        for (const link of this.querySelectorAll('[data-festival-apply-href]')) {
          link.setAttribute('href', link.dataset.festivalApplyHref);
          const action = link.querySelector('[data-festival-action]');
          if (action) action.textContent = link.dataset.festivalApplyLabel;
          link.removeAttribute('data-festival-apply-href');
        }
      }
      const label = this.querySelector('[data-festival-label]');
      const clock = this.querySelector('[data-festival-clock]');
      if (!label || !clock) return;
      label.textContent = upcoming ? this.dataset.startLabel : this.dataset.endLabel;
      const minutes = Math.max(0, Math.ceil(((upcoming ? start : end) - now) / 60000));
      const days = Math.floor(minutes / 1440);
      const hours = Math.floor((minutes % 1440) / 60);
      const remainder = minutes % 60;
      clock.textContent = `${String(days).padStart(2, '0')}d ${String(hours).padStart(2, '0')}h ${String(remainder).padStart(2, '0')}m`;
      clock.hidden = false;
    }
  }
  if (!customElements.get('luvee-festival')) customElements.define('luvee-festival', LuveeFestival);
})();

